<template>
  <ServiceLayout
    icon="notext-starx.png"
    title="StarX"
    description="Cocok untuk anda yang ingin berpergian bersama keluarga atau sahabat dengan jumlah kapasitas mulai dari 1-4 orang (hanya berlaku untuk perjalanan dalam kota)."
    :extra_hour="1"
    :tariffs="starx_tariffs"
    :lists="starx_list"
  />
</template>

<script>
import ServiceLayout from '@/components/ServiceLayout'

export default {
  name: 'StarX',
  components: {
    'ServiceLayout': ServiceLayout
  },
  data () {
    return {
      starx_list: [
        {
          icon: 'kapasitas-starx.png',
          icon_position: 'left',
          title: 'Kapasitas',
          subtitle: 'Cocok untuk anda yang memiliki keluarga, teman, atau sahabat dekat yang ingin bepergian dengan kapasitas 1 – 4 orang.'
        },
        {
          icon: 'tarif-pasti.png',
          icon_position: 'right',
          title: 'Tarif Pasti',
          subtitle: 'Kami memberikan tarif pasti kepada setiap Member STARGUIDES dan tidak perlu khawatir tawar menawar lagi karna biaya nya sudah pasti.'
        },
        {
          icon: 'friendly.png',
          icon_position: 'left',
          title: 'Friendly',
          subtitle: 'Guiders kami akan selalu memberikan pelayanan dan sikap yang terbaik bagi semua member STARGUIDES.'
        },
        {
          icon: 'aman-nyaman.png',
          icon_position: 'right',
          title: 'Aman dan Nyaman',
          subtitle: 'Guiders kami akan selalu berusaha untuk memberikan keamanan dan kenyamanan selama bepergian di kota yang anda kunjungi dengan STARX.'
        },
        {
          icon: 'kemudahan-pembayaran.png',
          icon_position: 'left',
          title: 'Kemudahan Pembayaran',
          subtitle: 'Tidak perlu khawatir soal uang kembalian atau uang tunai, dengan, kartu kredit, layanan kami kini semakin praktis.'
        }
      ],
      starx_tariffs: [
        'Rp. 1.868.160* per hari (Eropa, Turki, Jepang, Korea, Tiongkok)',
        'Rp. 506.400* per hari (Malaysia)'
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Service/StarX.vue